import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class SignalRService {
  public connection = new BehaviorSubject<any>(null);

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  public init(){
    return;
    let connection = window['$'].connection(this.config.api + '/notify?tenantName=' + LoginHelper.getTenantName());

    connection.start({}, () => {
      debugger;
      this.connection.next(connection);
    });
  }
}
